
















import { defineComponent } from '@vue/composition-api'
import { Popover } from 'element-ui'

export default defineComponent({
  name: 'KiswePopover',
  components: {
    'el-popover': Popover
  },
  inheritAttrs: false,
  data: () => ({
    showPopupContents: false
  }),
  methods: {
    onShow (...restArgs: any) {
      this.showPopupContents = true
      this.$emit('show', ...restArgs)
    },
    onHide (...restArgs: any) {
      this.showPopupContents = false
      this.$emit('hide', ...restArgs)
    },
    onInput (...restArgs: any) {
      this.$emit('input', ...restArgs)
    }
  }
})

